import { render, staticRenderFns } from "./AttendanceClockStats.vue?vue&type=template&id=195ff79e&scoped=true&"
import script from "./AttendanceClockStats.vue?vue&type=script&lang=js&"
export * from "./AttendanceClockStats.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceClockStats.vue?vue&type=style&index=0&id=195ff79e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ff79e",
  null
  
)

export default component.exports